import React from 'react';

/**
 * Legend: color swatch + device name for each path on the map.
 */
export default function MapLegend({ paths }) {
  if (!paths || paths.length === 0) return null;
  return (
    <div className="absolute bottom-4 left-4 z-[1000] bg-white/95 rounded-lg shadow-md border border-gray-200 p-3 max-w-xs">
      <div className="text-xs font-semibold text-gray-600 mb-2">Devices</div>
      <ul className="space-y-1.5">
        {paths.map(({ deviceName, color }) => (
          <li key={deviceName} className="flex items-center gap-2 text-sm">
            <span
              className="inline-block w-4 h-4 rounded-full flex-shrink-0"
              style={{ backgroundColor: color }}
            />
            <span className="truncate">{deviceName}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
